import { create } from 'zustand';
import { ClientType } from 'wb-spotify/app/routes/superGrid/mutator/adAccount/utils/utils';
import { RowNode, GridApi } from 'ag-grid-community';

export type MutatingClient = Partial<ClientType> & {
	node?: RowNode
	api?: GridApi
	userGroups: any
};

export const newClient: MutatingClient = {
	adAccountId:   '',
	adAccountName: '',
	userGroups:    [],
};

type SpotifyClientMutatorState = {
	mutatingClient?: MutatingClient;
	setMutatingClient: (mutatingClient?: MutatingClient) => void;
};

const useSpotifyClientMutator = create<SpotifyClientMutatorState>((set) => ({
	mutatingClient:    undefined,
	setMutatingClient: (mutatingClient) => set({ mutatingClient }),
}));

export default useSpotifyClientMutator;
